// extracted by mini-css-extract-plugin
export default {"privacyContainer":"privacy_privacyContainer__j+SJD","imgContainer":"privacy_imgContainer__Dxth1","div":"privacy_div__jfvQC"};